// var sensors = require('sa-sdk-javascript');
import sensors from 'sa-sdk-javascript';
import {getUser} from './tools';
sensors.registerPage({
  platform_type: 'h5',
  site_name: '患者端H5',
});
sensors.init({
  server_url: `https://datareport-sc.gstyun.cn/sa?project=default`,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  show_log: true,
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default',
    collect_tags: {
      div: true,
      li: true,
    },
  },
});
sensors.quick('autoTrack');
export const initH5 = () => {
  console.log('initH5---')
  if (getUser().user_id) {
    sensors.login('h5_' + getUser().user_id);
  }
}
export default sensors;
